/*global VeloxWebView*/

/**
 * This interceptor add a class to the #main div corresponding to the current route
 * The main purpose is to display different background depending on current screen
 */
module.exports = [
    {
        type: "navigation", //called on navigation
        interceptor: function (app, context, next){

            var currentRoute = app._getRoutes(app._currentPosition()) ;

            var mainClassName = "" ;
            if(currentRoute.length > 0){
                var lastPosition = currentRoute[currentRoute.length - 1].urlPosition ;
                var firstLastRoute = currentRoute.filter(function(r){ return r.urlPosition === lastPosition ;})[0] ;
                mainClassName = firstLastRoute.route.replace("/", "-") ;
            } ;

            document.getElementById("main").className = mainClassName ;

            next() ;
        }
    }
];